const NAV_MOBILE_MENU = Object.freeze({
    TRANSITION_DURATION: 300,
}); 

class NavMobileMenu {
    constructor () {
        const ns = 'nav-mobile-menu';

        this.selectors = {
            navMobileMenu: `.${ ns }`,
            toggleButton: `.${ ns }__toggle-button`,
            searchButton: `.${ ns }__panel-button.search`,
            backButton: `.${ ns }__panel-button.back`,
            closeButton: `.${ ns }__panel-button.close`,
            quicksearch: `.${ ns }__quicksearch`,
            searchInput: `.${ ns }__quicksearch input.search-input-mobile`,
            topNavLink: `.${ ns } button.${ ns }__top-nav-link`,
            openPanelRight: `.${ ns }__panel-right.is-open`,
        };

        this.elements = {
            navMobileMenu: document.querySelector(this.selectors.navMobileMenu),
            toggleButton: document.querySelector(this.selectors.toggleButton),
            searchButton: document.querySelector(this.selectors.searchButton),
            backButtons: document.querySelectorAll(this.selectors.backButton),
            closeButtons: document.querySelectorAll(this.selectors.closeButton),
            quicksearch: document.querySelector(this.selectors.quicksearch),
            searchInput: document.querySelector(this.selectors.searchInput),
            topNavLinks: document.querySelectorAll(this.selectors.topNavLink),
            getPanelRight: (panel) => document.querySelector(`.${ ns } [data-panel-right="${ panel }"]`),
        };
    }

    disableBodyScroll () {
        document.body.classList.add('modal-open');
    }

    enableBodyScroll () {
        document.body.classList.remove('modal-open');
    }

    wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    openMenu () {
        this.elements.navMobileMenu.classList.add('is-open');
        this.elements.navMobileMenu.classList.remove('no-animation');
        this.disableBodyScroll();
    }

    closeMenu () {
        this.elements.navMobileMenu.classList.remove('is-open');
        this.enableBodyScroll();

        this.wait(NAV_MOBILE_MENU.TRANSITION_DURATION).then(() => {
            this.elements.navMobileMenu?.classList.remove('sub-nav-is-open');
            document.querySelector(this.selectors.openPanelRight)?.classList.remove('is-open');
            this.elements.navMobileMenu.classList.add('no-animation');
        });
    }

    openSubNav (e) {
        const subPanel = e.target.closest('li').dataset.subPanel;

        this.elements.navMobileMenu.classList.add('sub-nav-is-open');
        this.elements.getPanelRight(subPanel).classList.add('is-open');
    }

    closeSubNav () {
        this.elements.navMobileMenu.classList.remove('sub-nav-is-open');

        this.wait(NAV_MOBILE_MENU.TRANSITION_DURATION).then(() => {
            document.querySelector(this.selectors.openPanelRight)?.classList.remove('is-open');
        });
    }

    toggleMobileSearch () {
        this.elements.quicksearch.classList.toggle('is-open');
        this.elements.searchInput.focus();
    }

    handleSubmitCloses () { }

    bindEvents () {
        this.elements.toggleButton.addEventListener('click', this.openMenu.bind(this));
        this.elements.searchButton.addEventListener('click', this.toggleMobileSearch.bind(this));

        this.elements.backButtons.forEach((button) => {
            button.addEventListener('click', this.closeSubNav.bind(this));
        });

        this.elements.closeButtons.forEach((button) => {
            button.addEventListener('click', this.closeMenu.bind(this));
        });

        this.elements.topNavLinks.forEach((link) => {
            link.addEventListener('click', this.openSubNav.bind(this));
        });
    }

    init () {
        this.bindEvents();
    }
}

const navMobileMenu = new NavMobileMenu();

navMobileMenu.init();
